import React from 'react';
import { useTranslation } from 'react-i18next';

import Switch from 'shared/_styles/Switch.style';
import * as Text from 'theme/components/Text.style';
import * as Section from 'settings/styles/SettingsSection.style';
import type { PushStatus } from 'pwa/helpers/pushNotifications';

export interface DeviceNotificationsRowProps {
  status: PushStatus | null;
  isBusy: boolean;
  hasFailed: boolean;
  onEnable: () => void;
  onDisable: () => void;
}

const HINT_KEYS: Partial<Record<PushStatus, string>> = {
  'needs-install': 'notifications.device.hint.needsInstall',
  unsupported: 'notifications.device.hint.unsupported',
  blocked: 'notifications.device.hint.blocked',
};

export default function DeviceNotificationsRow({
  status,
  isBusy,
  hasFailed,
  onEnable,
  onDisable,
}: DeviceNotificationsRowProps): JSX.Element {
  const { t } = useTranslation('pageSettings');
  const hintKey = hasFailed
    ? 'notifications.device.hint.failed'
    : status && HINT_KEYS[status];
  const canToggle = status === 'on' || status === 'off';

  return (
    <Section.RowListItem>
      <Section.RowLabel>
        <Text.P2Semibold>{t('notifications.device.label')}</Text.P2Semibold>
        {hintKey && <Text.Label>{t(hintKey)}</Text.Label>}
      </Section.RowLabel>
      <Section.RowControl>
        <Switch
          checked={status === 'on'}
          disabled={!canToggle || isBusy}
          inputProps={{ 'aria-label': t('notifications.device.label') }}
          onChange={(event) =>
            event.target.checked ? onEnable() : onDisable()
          }
        />
      </Section.RowControl>
    </Section.RowListItem>
  );
}
